import { FtpSettingsStateType } from './state'

export interface FtpSettingsGettersType {
  getFtpSettingsById: (state: FtpSettingsStateType, id: string) => FtpSettingsStateType['ftpSetting']
  getFtpSettingsByHost: (state: FtpSettingsStateType, host: string) => FtpSettingsStateType['ftpSetting']
  getFtpSettingsByMode: (state: FtpSettingsStateType, mode: string) => FtpSettingsStateType['ftpSettings']
}

export const FtpSettingsGetters = {
  getFtpSettingsById: (state: FtpSettingsStateType) => (id: string) => {
    return state.ftpSettings.find(ftpSetting => ftpSetting.id === id)
  },
  getFtpSettingsByHost: (state: FtpSettingsStateType) => (host: string) => {
    return state.ftpSettings.find(ftpSetting => ftpSetting.host === host)
  },
  getFtpSettingsByMode: (state: FtpSettingsStateType) => (mode: string) => {
    return state.ftpSettings.filter(ftpSetting => ftpSetting.mode === mode)
  },
}
